<script setup>
definePage({ meta: { ...PageMeta.Orders.Add.Meta, pageTitle: PageMeta.Orders.Add.Title } })

import OrdersCreatePage from '@/views/Previews/Orders/OrdersCreatePage.vue'
</script>

<template>
  <OrdersCreatePage />
</template>
